import { useMemo } from 'react';
import { useUser } from 'hooks/redux/useUser';

export function useOrigin(origin) {
  const { user } = useUser();

  return useMemo(() => {
    return origin || user.group;
  }, [origin, user]);
}
